<template>
  <div class="rv-header">
    <div class="rv-logo-wrap" :class="logoBrand == 'rvMy' ? 'rv-my-desktop' : ''">
      <a class="rv-logo" :href="logoUrl" onclick="" :aria-label="$t('headerLogoLabel')">
        <img v-show="logoBrand == 'rvMy'" :src="require('@/assets/rvMyLogo.png')" class="rv-my-desktop"/>
        <img v-show="logoBrand == 'rvMyMobile'" :src="require('@/assets/rvMyMobile.png')" class="rv-my-mobile"/>
        <img v-if="logoBrand == 'ravensburger'" :src="require('@/assets/ravensburger.svg')"/>
        <img v-if="logoBrand == 'brio'" :src="require('@/assets/brio.svg')"/>
        <img v-if="logoBrand == 'thinkfun'" :src="require('@/assets/thinkfun.svg')"/>
      </a>
    </div>
    <headline/>
  </div>

</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import Headline from "@/components/common/Headline.vue";
import { AppModule } from '@/store/modules/app';
export default {
    components: {
      
      Headline 
    },
    data() {
      return {
        windowWidth: 0
      }
    },
    computed: {
      logoUrl: function() {
        return AppModule.session.cancelUri
      },
      logoBrand: function() {
        if (this.logoUrl.includes('rvmytest') || this.logoUrl.includes('myravensburger')) {
          if (this.windowWidth > 1145) {
            return 'rvMy'
          } else {
            return 'rvMyMobile'
          }
        } else if (this.logoUrl.includes('rvustest') || this.logoUrl.includes('ravensburger.us')) {
          return 'ravensburger'
        } else if (this.logoUrl.includes('brio')) {
          return 'brio'
        } else if (this.logoUrl.includes('thinkfun')) {
         return 'thinkfun'
        } else {
          return 'ravensburger'
        }
      }
    },
    mounted: function() {
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth()
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWindowWidth);
    },
    methods: {
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      }
    }
}
</script>

<style lang="scss">
#app {
  .rv-header{
    z-index: 1000;
    top: 0px;
    position: fixed;
    width: 100%;
    height: 50px;
    background-color: $rv-white;

    .rv-logo-wrap {
      position: absolute;
      left: 24px;
      display: flex;
      align-items: center;
      height: 100%;
      width: 58px;
      margin-left: env(safe-area-inset-left);

      .rv-logo {
        img {
          max-height: 40px;
          width: 100%;
          height: 100%;

          &.rv-my-desktop {
            width: auto;
            height: 36px;
          }
        }
      }
    }

    #rv-headline{
      display:none;
    }

    @media (max-width: $rv-doubleTeaserBreakpoint) {
      border-bottom: 2px $rv-pressFilterGrey solid;
      height: 68px;

      .rv-logo-wrap {
        left: 12px;
        width: 40px;

        .rv-logo {
          z-index:1;
          img {
            max-height: 40px;

            &.rv-my-mobile {
              width: auto;
              max-height: 50px;
              height: 50px;
            }
          }
        }
      }
      .rv-bigHeadline{
        display:none;
      }
      #rv-headline{
        display:block;
      }
    }
  }
}
</style>